jQuery(document).ready(function ($) {

  /* Burger Menu */
  jQuery('.burger').click(function (e) {
    e.preventDefault();
    jQuery('.mobile-navigation').toggleClass('toggled');
    jQuery('.burger').toggleClass('open');
    $('body').toggleClass('overflow-hidden'); // prevent background scroll
  });



  if ($('.hero-one').hasClass('has-white-color')) {
    $('.header').addClass('has-white-color');
  } else {
    $('.header').addClass('has-black-color');
  }

  var header = $('.header .top-bar');
  $(window).scroll(function () {
    var scroll = $(window).scrollTop();
    if (scroll >= 10) {
      header.hide();
      $('.main-navigation').addClass('scrollheader has-black-color');
      $('#menu-dot').addClass('!bg-black');
      $('.main-logo-dark-scroller').show();
      //$(".mobile-navigation").addClass("scrolling");
    } else {
      header.show();
      $('.main-navigation').removeClass('scrollheader has-black-color');
      $('#menu-dot').removeClass('!bg-black');
      $('.main-logo-dark-scroller').hide();
    }
  });

  $('.accordion-content').not(':first').hide();
  $('.accordion-header').on('click', function () {
    let $header = $(this);
    let $content = $header.next('.accordion-content');

    // Close all other accordions
    $('.accordion-header')
      .not($header)
      .removeClass('active')
      .find('.icon')
    $('.accordion-content').not($content).slideUp();

    // Toggle this one
    $header.toggleClass('active');
    $content.stop().slideToggle();

    // Toggle icon (+ / -)
    //$header.find('.icon').toggleClass('fa-arrow-right-long fa-arrow-up-long');
  });

  // Make draggable with jQuery UI
  $('.moveable').sortable({
    items: 'div',
    stop: function () {
      $grid.masonry('reloadItems').masonry();
    },
  });

  const popupSearch = document.querySelector('.popup-search');

  function openSearch() {
    popupSearch.classList.remove('hidden');
    // Trigger reflow so the transition fires
    popupSearch.offsetHeight;
    popupSearch.classList.add('opacity-100');
    popupSearch.classList.remove('opacity-0');
  }

  function closeSearch() {
    popupSearch.classList.remove('opacity-100');
    popupSearch.classList.add('opacity-0');
    // Wait for the fade-out transition to finish before hiding
    popupSearch.addEventListener('transitionend', () => {
      popupSearch.classList.add('hidden');
    }, { once: true });
  }

  if (popupSearch) {
    $(document).on('click', '.header-search-icon', function (e) {
      e.preventDefault();
      openSearch();
    });

    popupSearch.addEventListener('click', (e) => {
      // Only close if clicking the backdrop, not the search box inside
      if (e.target === popupSearch) {
        closeSearch();
      }
    });
  }
});

var elms = document.getElementsByClassName('splide');

for (var i = 0; i < elms.length; i++) {
  (function (elm) {
    var splide = new Splide(elm, {
      type: 'loop',
      perPage: 1,
    });

    var counter = elm.querySelector('.counter');

    // Helper to format numbers as 2-digits
    function pad(num) {
      return String(num).padStart(2, '0');
    }

    splide.on('mounted move', function () {
      var current = splide.index + 1;
      var total = splide.length;
      if (counter) {
        counter.textContent = pad(current) + ' - ' + pad(total);
      }
    });

    splide.mount();
  })(elms[i]);
}

//GSAP Code

// Parallax
document.addEventListener('DOMContentLoaded', function (event) {
  //wait until images, links, fonts, stylesheets, and js is loaded
  window.addEventListener('load', function (e) {
    //custom GSAP code goes here

    gsap.registerPlugin(ScrollTrigger);

    gsap.utils.toArray('.parallax').forEach((panel, i) => {
      ScrollTrigger.create({
        trigger: panel,
        start: 'top top',
        pin: true,
        pinSpacing: false,
      });
    });
    gsap.from('.staggered-ctas .thevideo', {
      y: 50,
      opacity: 0,
      duration: 0.6,
      ease: 'power3.out',
      stagger: 0.2,
      scrollTrigger: {
        trigger: '.staggered-ctas',
        start: 'top 50%', // animation starts when section hits 80% of viewport
        toggleActions: 'play none none none',
        // options: onEnter, onLeave, onEnterBack, onLeaveBack
      },
    });
  });
});

const counters = [
  { el: document.getElementById('counter1'), final: 169 },
  { el: document.getElementById('counter2'), final: 968 },
  { el: document.getElementById('counter3'), final: 257 },
];

ScrollTrigger.create({
  trigger: '.results',
  start: 'top 80%', // adjust as needed
  once: true, // only trigger once
  onEnter: () => {
    counters.forEach(({ el, final }) => {
      gsap.to(
        {},
        {
          duration: 0.1, // speed of random change
          repeat: 25, // number of random jumps
          onRepeat: () => {
            const randomNum = Math.floor(Math.random() * final);
            el.textContent = randomNum.toLocaleString();
          },
          onComplete: () => {
            el.textContent = final.toLocaleString();
          },
        }
      );
    });
  },
});



$('#project-filters a').on('click', function () {
  const filter = $(this).data('filter');
  const items = $('.project-item');

  // Animate out current items
  gsap.to(items, {
    opacity: 0,
    y: 20,
    duration: 0.3,
    onComplete: () => {
      items.hide();

      // Show filtered items
      if (filter === 'all') {
        items.show();
      } else {
        items.filter(function () {
          return $(this).data('category').split(' ').includes(filter);
        }).show();
      }

      // Animate in filtered items
      gsap.fromTo($('.project-item:visible'),
        { opacity: 0, y: -20 },
        { opacity: 1, y: 0, duration: 0.4, stagger: 0.1 }
      );
    }
  });
});

// Menu Dot Animation
document.addEventListener('DOMContentLoaded', function () {
  const dot = document.getElementById('menu-dot');
  const mainMenu = document.getElementById('main-menu');

  if (dot && mainMenu) {
    const firstUl = mainMenu.querySelector('ul');
    // Get all top-level <a> elements
    const allLinks = firstUl ? Array.from(firstUl.children).map(li => li.querySelector('a')).filter(Boolean) : [];

    // Remove the dot from the last menu item
    const lastLink = allLinks.length > 0 ? allLinks.pop() : null;
    const topLevelLinks = allLinks; // now contains all except the last element

    function moveDot(link) {
      const menuRect = mainMenu.getBoundingClientRect();
      const indicator = link.querySelector('.mega-indicator');
      let leftPos, topPos;

      if (indicator) {
        const indRect = indicator.getBoundingClientRect();
        // Place dot on the mega-indicator (centered horizontally and vertically)
        leftPos = indRect.left - menuRect.left + (indRect.width / 2) - 4; // 4px is half of the dot's w-2 (8px) width
        topPos = indRect.top - menuRect.top + (indRect.height / 2);
      } else {
        const linkRect = link.getBoundingClientRect();
        leftPos = linkRect.right - menuRect.left + 2;
        topPos = linkRect.top - menuRect.top + (linkRect.height / 2);
      }

      // We maintain the -translate-y-1/2 from Tailwind using top: 50% logic or transform
      dot.style.transform = `translate(0, -50%)`;
      dot.style.left = leftPos + 'px';
      dot.style.top = topPos + 'px';
      dot.style.opacity = 1;
    }

    topLevelLinks.forEach((link) => {
      link.addEventListener('mouseenter', () => moveDot(link));
    });

    if (lastLink) {
      lastLink.addEventListener('mouseenter', () => {
        dot.style.opacity = 0; // hide dot when hovering the last menu item
      });
    }

    mainMenu.addEventListener('mouseleave', () => {
      // Return to the active item, or hide if no top-level active item exists
      const activeLink = mainMenu.querySelector('.current-menu-item > a, .current_page_item > a, .mega-current-menu-item > a');
      if (activeLink && topLevelLinks.includes(activeLink)) {
        moveDot(activeLink);
      } else {
        dot.style.opacity = 0;
      }
    });

    // Initial position on load
    setTimeout(() => {
      const activeLink = mainMenu.querySelector('.current-menu-item > a, .current_page_item > a, .mega-current-menu-item > a');
      if (activeLink && topLevelLinks.includes(activeLink)) {
        moveDot(activeLink);
      }
    }, 250);
  }

  // Search popup
  const searchIcon = document.querySelector('.header-search-icon');
  const popupSearch = document.querySelector('.popup-search');

  function openSearch() {
    popupSearch.classList.remove('hidden');
    // Trigger reflow so the transition fires
    popupSearch.offsetHeight;
    popupSearch.classList.add('opacity-100');
    popupSearch.classList.remove('opacity-0');
  }

  function closeSearch() {
    popupSearch.classList.remove('opacity-100');
    popupSearch.classList.add('opacity-0');
    // Wait for the fade-out transition to finish before hiding
    popupSearch.addEventListener('transitionend', () => {
      popupSearch.classList.add('hidden');
    }, { once: true });
  }

  if (searchIcon && popupSearch) {
    searchIcon.addEventListener('click', (e) => {
      e.preventDefault();
      openSearch();
    });

    popupSearch.addEventListener('click', (e) => {
      // Only close if clicking the backdrop, not the search box inside
      if (e.target === popupSearch) {
        closeSearch();
      }
    });
  }
});


